module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Triturado.c0e82696.pdf";